import { memo } from "react";
import { useElement, useLocale } from "../../../hooks";
import { useTrashConfirmModal } from "./hooks";

interface TrashConfirmModalProps {
  trashCancelAction?: () => void;
  showTrashConfirm?: boolean;
  isMultipleDelete?: boolean;
  trashOkAction?: () => void;
}

export const TrashConfirmModal = memo(
  ({
    trashCancelAction,
    showTrashConfirm,
    isMultipleDelete,
    trashOkAction,
  }: TrashConfirmModalProps) => {
    const { t } = useLocale();
    const Button = useElement("Button");
    const { trashCancel } = useTrashConfirmModal({
      trashCancelAction,
      showTrashConfirm,
    });

    return (
      <div className="modal" id="trash-modal">
        <div className="modal-backdrop"></div>
        <div className="modal-content small">
          {trashCancelAction && (
            <Button className="close" onClick={trashCancel}>
              <i className="hi-close"></i>
            </Button>
          )}
          <div className="modal-body p20">
            <i className="hi-close"></i>
            <span className="store-name">
              {isMultipleDelete
                ? t("confirmDelete.multiple")
                : t("confirmDelete.single")}
            </span>
            <div className="flex btn-box-trash">
              {trashOkAction && (
                <Button
                  className="btn btn-primary btn-box"
                  onClick={trashOkAction}
                >
                  {t("delete")}
                </Button>
              )}
              {trashCancelAction && (
                <Button
                  className="btn btn-box btn-outline"
                  onClick={trashCancel}
                >
                  {t("cancel")}
                </Button>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
);
